import { Component, OnInit } from '@angular/core'
import { PageDefinition } from './types'
import { ApplicationArea } from '../shared/services/ppv.api'
import { AuthManager } from '../shared/auth/AuthManager'
import { Router } from '@angular/router'

const LTK_DASHBOARD_ROUTE = '/leader-toolkit-ops-dashboard'
const LTK_HM_DASHBOARD_ROUTE = '/leader-toolkit-hospital-dashboard'

@Component({
   selector: 'app-landing',
   template: '',
   standalone: false,
})
export class LandingComponent implements OnInit {
   allPages: PageDefinition[] = [
      {
         iconString: 'fa-user-tie',
         color: 'appButton-purple',
         title: 'Employee Map',
         routerLink: '/employee-type-mapper',
         requiredRole: { application: ApplicationArea.EmployeeTypeMap },
      },
      {
         iconString: 'fa-exchange-alt',
         color: 'appButton-green',
         title: 'Escheatment',
         routerLink: '/escheatment',
         requiredRole: { application: ApplicationArea.Escheatment },
      },
      {
         iconString: 'fa-hand-holding-usd',
         color: 'appButton-red',
         title: 'Payment Group Map',
         routerLink: '/payment-group-map',
         requiredRole: { application: ApplicationArea.PaymentGroupMap },
      },
      {
         iconString: 'fa-phone',
         color: 'appButton-orange',
         title: 'Tail-O-Phone',
         routerLink: '/tail-o-phone',
      },
      {
         iconString: 'fa-calendar',
         color: 'appButton-yellow',
         title: 'Schedule Template',
         routerLink: '/schedule-template',
         requiredRole: { application: ApplicationArea.DoctorSchedule },
      },
      {
         iconString: 'fa-boxes',
         color: 'appButton-blue',
         title: 'Service and Product Mapper',
         routerLink: '/products',
         requiredRole: { application: ApplicationArea.Products },
      },
      {
         iconString: 'fa-comment-dollar',
         color: 'appButton-teal',
         title: 'Pricing Manager',
         routerLink: '/vetcor-pricing',
         requiredRole: { application: ApplicationArea.PricingManager },
      },
      {
         iconString: 'fa-trophy',
         color: 'appButton-blue',
         title: 'Summer Splash Contest',
         routerLink: '/summer-splash-contest',
         requiredRole: { application: ApplicationArea.Leaderboard, roleName: ['Leaderboard', 'HospitalManager', 'RM'] },
      },
      {
         iconString: 'fa-tasks',
         color: 'appButton-teal',
         title: 'Mentorship',
         routerLink: '/mentorship',
         requiredRole: { application: ApplicationArea.Mentoring },
      },
      {
         iconString: 'fa-arrow-trend-up',
         color: 'appButton-red',
         title: 'Growth Toolkit',
         routerLink: '/growth-toolkit',
         requiredRole: { application: ApplicationArea.GrowthToolkit },
      },
      {
         iconString: 'fa-arrow-trend-up',
         color: 'appButton-red',
         title: 'Leader Toolkit',
         routerLink: LTK_DASHBOARD_ROUTE,
         requiredRole: { application: ApplicationArea.LTK },
      },

      {
         iconString: 'fa-clipboard-user',
         color: 'appButton-yellow',
         title: 'DVM Engagement',
         routerLink: '/dvm-engagement',
         requiredRole: { application: ApplicationArea.DVMTool, roleName: ['DVMToolAdmin', 'DVM', 'RM', 'OpsVP', 'OpsDirector'] },
      },

      /*
      {
         iconString: 'fa-fax',
         color: 'appButton-red',
         title: 'Fax Manager',
         routerLink: '/fax-manager/fax-manager-dashboard',
         requiredRole: { application: ApplicationArea.FaxManager },
      },     
      */
      {
         iconString: 'fa-clipboard-user',
         color: 'appButton-purple',
         title: 'Entra Sync',
         routerLink: '/entra-sync',
         requiredRole: { application: ApplicationArea.EntraSync },
      },
      {
         iconString: 'fa-comments',
         color: 'appButton-red',
         title: 'Messaging App',
         routerLink: '/messaging',
         requiredRole: { application: ApplicationArea.Messaging },
      },
      {
         iconString: 'fa-comments',
         color: 'appButton-red',
         title: 'Role Manager',
         routerLink: '/role-manager',
         requiredRole: { application: ApplicationArea.RoleManager },
      },
      
   ]

   constructor(private authMgr: AuthManager, private router: Router) {}

   ngOnInit() {
      this.authMgr.getCurrentUser().subscribe((user) => {
         const isHM = (user.roles || []).some(
            (r) => r.application === ApplicationArea.LTK && r.roleName === 'HM'
         )

         if (this.authMgr.canAccess(user, { application: ApplicationArea.LTK })) {
            this.router.navigate([isHM ? LTK_HM_DASHBOARD_ROUTE : LTK_DASHBOARD_ROUTE], { replaceUrl: true })
            return
         }

         const target = this.allPages.find(
            (item) => item.requiredRole == null || this.authMgr.canAccess(user, item.requiredRole)
         )
         if (target != null) {
            this.router.navigate([target.routerLink], { replaceUrl: true })
         }
      })
   }
}
